module.exports = __webpack_public_path__ + "img/desktop-research&report.a2b56af2.png";